export default {
    addReports:null,
    screensWeb:[]
}